import { DEFAULT_LANDING_PAGE_PATH, resolveLandingPagePath } from '../routing';
import { qmLandingPageConfig } from './academy-de/qm-landingpage/config';
import { academyEsConfig } from './academy-es/in-company-training/config';
import { academyInConfig } from './academy-in/accs/config';
import { academyInIcpConfig } from './academy-in/icp/config';
import { academyInCisoConfig } from './academy-in/ciso/config';
import { academyItConfig } from './academy-it/sustainability-masterclass/config';
import { academyUsConfig } from './academy-us/fusa-machinery/config';
import type { MarketConfig } from './types';

export const marketConfigs = {
  'aca-de-qm': qmLandingPageConfig,
  'aca-es-incompany': academyEsConfig,
  'aca-in-accs': academyInConfig,
  'aca-in-icp': academyInIcpConfig,
  'aca-in-ciso': academyInCisoConfig,
  'aca-it-sustainability': academyItConfig,
  'aca-us-fusa-machinery': academyUsConfig,
} satisfies Record<string, MarketConfig>;

function getMarketSlugFromPath(pathname: string): keyof typeof marketConfigs {
  const resolvedPath = resolveLandingPagePath(pathname);
  if (resolvedPath in marketConfigs) return resolvedPath as keyof typeof marketConfigs;
  return DEFAULT_LANDING_PAGE_PATH;
}

export function getMarketConfig(pathname: string): MarketConfig {
  return marketConfigs[getMarketSlugFromPath(pathname)];
}

export function getAllMarketConfigs(): MarketConfig[] {
  return Object.values(marketConfigs);
}

export function getLandingPageMetaConfig(pathname: string) {
  const market = getMarketConfig(pathname);

  return {
    title: market.title,
    description: market.description,
    themeColor: market.themeColor,
    ogImage: market.ogImage,
    ogImageAlt: market.ogImageAlt,
    twitterCard: market.twitterCard,
    robots: market.robots,
  };
}
